import { render, staticRenderFns } from "./swiperHome.vue?vue&type=template&id=450c2daf&"
import script from "./swiperHome.vue?vue&type=script&lang=js&"
export * from "./swiperHome.vue?vue&type=script&lang=js&"
import style0 from "./swiperHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450c2daf')) {
      api.createRecord('450c2daf', component.options)
    } else {
      api.reload('450c2daf', component.options)
    }
    module.hot.accept("./swiperHome.vue?vue&type=template&id=450c2daf&", function () {
      api.rerender('450c2daf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swiperHome/swiperHome.vue"
export default component.exports